import { useTranslation } from 'react-i18next';
import { useRootSelector } from '../../../../../store/hooks';
import { selectSiteHeader } from '../../../../../store/features/siteHeader';
import PaymentProvider from '../../../shared/PaymentProvider';
import Layout from '../../../shared/layouts/Layout';
import { MetaTags } from '../../../../hub/shared/MetaTags';
import PageLayout from '../../../shared/layouts/PageLayout';
import BookingClosedMessage, {
  BookingClosedMessageProps,
} from '../components/BookingClosedMessage';

interface BookingClosedProps extends BookingClosedMessageProps {}

export default function BookingClosed(props: BookingClosedProps) {
  const { errorMessage, ...restProps } = props;
  const { t } = useTranslation();
  const siteHeader = useRootSelector(selectSiteHeader);
  const title = siteHeader?.meta?.title || siteHeader?.data?.title || '';
  const pageTitle = title
    ? `${t('site.pricing.booking-closed')} | ${title}`
    : t('site.pricing.booking-closed');

  return (
    <PaymentProvider>
      <Layout disableUpperFooter>
        <MetaTags title={pageTitle} />
        <PageLayout variant="full">
          <BookingClosedMessage errorMessage={errorMessage} {...restProps} />
        </PageLayout>
      </Layout>
    </PaymentProvider>
  );
}
